import { useEffect, useState } from 'react';
import store from '../../store/store';
import { verifyToken } from '../../store/api/signin';
import { getUserContext, isSessionValid, updateUserContext } from '../utils/utils';
import { cookieNames } from '../constants/constants';
import useLogout from './useLogout';

export default function useAuth(triggerAuth: any) {
  const { logout } = useLogout();
  const [loggedIn, setLoggedIn] = useState<boolean | undefined>();
  useEffect(() => {
    const sessionValid = isSessionValid(cookieNames.jwtToken);
    if (!sessionValid) {
      setLoggedIn(false);
      return;
    }

    store.dispatch(verifyToken()).then((res: any) => {
      if (res.payload?.status === 201 && res.payload?.data?.session?.party) {
        setLoggedIn(true);
        const party = res.payload.data.session.party;
        const refreshedToken = res.payload.data.refreshedToken;
        const userContext: any = getUserContext();
        
        // Update user context if there's a refreshed token or if user context is missing
        if (refreshedToken && refreshedToken !== "") {
          console.log('Token refreshed via verifyToken API');
          updateUserContext(party.roles, party.permissions, party.partyId, "", party.statusId, party.orgPartyRole, party.orgPartyIds, party.orgPartyName,
            refreshedToken, false);
        } else if (!userContext || !userContext.partyId || userContext.partyId == "") {
          // Only update if user context is missing, don't update with empty token
          updateUserContext(party.roles, party.permissions, party.partyId, "", party.statusId, party.orgPartyRole, party.orgPartyIds, party.orgPartyName,
            "", false);
        }
      } else {
        setLoggedIn(false);
        // Don't call logout() here - only call logout when there was a valid session that expired
        // logout() redirects to signin which interferes with registration flow
      }
    });
  }, [triggerAuth]);

  return loggedIn;
}